// Il tipo di notifica arriva come stringa camelCase (JsonStringEnumConverter, sia da SignalR sia
// dal feed REST). Un tipo sconosciuto - una notifica persistita da una versione piu' recente del
// backend - degrada sul copy generico di fallimento invece di rompere il rendering.
const COPY_BASE_BY_TYPE = {
  documentRetrievalFailed: "document-failed",
  documentYearMismatch: "document-year-mismatch",
};

const FALLBACK_COPY_BASE = COPY_BASE_BY_TYPE.documentRetrievalFailed;

export function notificationCopyKey(type, suffix) {
  const base = COPY_BASE_BY_TYPE[type] || FALLBACK_COPY_BASE;
  return `notifications.${base}-${suffix}`;
}
